import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// OBTENER TODAS LOS PRODUCTOS
export const obtenerProductos = async () => {
  const respuesta = await PrivateInterceptor(`Global/Productos`, "GET");
  return respuesta;
};

//OBTIENE DETALLE REQUISA POR REQUISA
export const obtenerProductosByIdType = async (Idtype) => {
  const result = await PrivateInterceptor(`Global/Productos/Idtype`,"POST",{ Idtype });
  return result;
};

//OBTIENE DETALLE REQUISA POR REQUISA
export const obtenerProductosCodigo = async (IdProduct) => {
  const result = await PrivateInterceptor(`Global/Productos/Codigo`,"POST",{ IdProduct });
  return result;
};

export const obtenerProductosAct = async () => {
  const respuesta = await PrivateInterceptor(`Global/Productos/Activos`, "GET");
  return respuesta;
};

// AGREGAR O MODIFICAR PRODUCTO
export const addProducto = async (data) => {
  const respuesta = await PrivateInterceptor(
    `Global/Productos/add`,
    "POST",
    data
  );
  return respuesta;
};

export const cambiarCodigoF = async (datos) => {
  const result = await PrivateInterceptor(`Global/Productos/CambiarCodigoF`,"POST",{ datos });
  return result;
};

